import { BasicInput } from '@/view/components/BasicInput'
import { Button } from '@/view/components/ui/button'
import { useNewPasswordController } from './useNewPasswordController'
import { FormProvider, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { newPasswordSchema, NewPasswordFormData } from '../components/types'

interface NewPasswordProps {
  token: string
}

export const NewPassword = ({ token }: NewPasswordProps) => {
  const methods = useForm<NewPasswordFormData>({
    resolver: zodResolver(newPasswordSchema),
    mode: 'onChange',
  })

  const { handleFormSubmit, isPending } = useNewPasswordController({ token })

  return (
    <FormProvider {...methods}>
      <div className="flex flex-col gap-6">
        <div className="text-center">
          <h2 className="mb-4 text-xl font-semibold text-gray-900">
            Redefinir senha
          </h2>
          <p className="text-sm text-gray-600">
            Sua senha deve conter no mínimo 8 caracteres, incluindo letras
            maiúsculas, minúsculas, números e caracteres especiais.
          </p>
        </div>

        <form
          onSubmit={methods.handleSubmit(handleFormSubmit)}
          className="flex w-full flex-col gap-4"
        >
          <BasicInput
            label="Nova senha"
            name="password"
            isPassword
            className="mt-1 h-11 max-w-full border-[1px] border-black04 font-medium placeholder:text-black04"
            error={methods.formState.errors.password?.message}
          />

          <BasicInput
            label="Confirmar nova senha"
            name="confirmPassword"
            isPassword
            className="mt-1 h-11 max-w-full border-[1px] border-black04 font-medium placeholder:text-black04"
            error={methods.formState.errors.confirmPassword?.message}
          />

          <Button
            type="submit"
            disabled={isPending}
            className="my-4 h-14 w-full bg-primary text-lg font-bold text-white01 hover:bg-primary hover:brightness-150"
          >
            {isPending ? 'Redefinindo...' : 'Redefinir senha'}
          </Button>
        </form>
      </div>
    </FormProvider>
  )
}
